export default "__VITE_ASSET__BJ8bn5Io__"